// react_frontend/src/hooks/useOfflineSync.js
import { useEffect } from 'react';
import { syncOfflineChanges } from '../utils/offlineSync';

export const useAutoSync = (apiUrl, token) => {
  useEffect(() => {
    const handleOnline = () => {
      if (token) {
        syncOfflineChanges(apiUrl, token);
      }
    };

    window.addEventListener('online', handleOnline);
    return () => window.removeEventListener('online', handleOnline);
  }, [apiUrl, token]);
};